import nioApi from './nioApiConfig.json';
import alpsApi from './alpsApiConfig.json';
import fyApi from './fyApiConfig.json';

export default {
  nioApi,
  alpsApi,
  fyApi,
};